import { push } from 'connected-react-router'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ROUTE_PATH } from '../../app/constants'
import { decideLegalAndOperatingNames, replaceUrlParams } from '../../app/utils'
import { SuccessPanel } from '../../components/MessagePanels/Panels'
import { Button } from '../../components/RegularComponents'
import { agencyApplicationSelector } from '../../redux/selector/agencyApplicationSelector'
import { titleStringFromLicenceSubType } from '../../redux/slice/applicationsUtils'
import { fetchApplicationWithIdAndSetStore } from '../../redux/slice/collectionApplicationSlice'

export const BranchApplicationPaymentConfirmation = (props) => {

    const dispatch = useDispatch()
    const { agencyApplication } = useSelector(agencyApplicationSelector);
    const { applicationType, applicationMode } = props.match.params

    const [legalName, setLegalName] = useState("")
    const [operatingName, setOperatingName] = useState("")

    const homePageUrl = replaceUrlParams(
        ROUTE_PATH.WELCOME, 
        applicationType, 
        applicationMode
    )

    const agencyTypeString = titleStringFromLicenceSubType(agencyApplication.licencingSubType);

    const renderHeader = () => {
        const label1 = (operatingName ? operatingName : (legalName ?? "Payment Confirmation"))
        const label2 = operatingName ? legalName : null

        return (
            <div className="row topMarginMedium">
                <div className="col-lg-8" style={{fontSize: "2.2rem"}}>
                    {label1}
                </div>
                {label2 && 
                <div className="col-lg-8" style={{fontSize: "1.6rem"}}>
                    {label2}
                </div>}
            </div>)
    }

    useEffect(() => {
        if(!agencyApplication?.businessLicenceData) {
            dispatch(fetchApplicationWithIdAndSetStore(agencyApplication.id))
                .then(data => {
                    const { legalName, operatingName} = decideLegalAndOperatingNames(data?.businessLicenceData?.companyRjscDetails)
                    setLegalName(legalName)
                    setOperatingName(operatingName)
                })
        }
    }, [
        agencyApplication?.businessLicenceData,
        agencyApplication?.id,
        dispatch
    ])

    return (
    <div className="container">
        { renderHeader() }
        <div className="row topMarginMedium">
            <div className="col-8">
                <SuccessPanel>
                    <h2>The application to add a new Branch has been submitted.</h2>
                </SuccessPanel>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-8 bottomMarginMedium">
                Your application will be reviewed by Business Licensing.
            </div>
            <div className="col-lg-8 bottomMarginMedium">
                If <b>more information</b> about your application is needed, <b>Business Licensing will contact you.</b>
            </div>
            <div className="col-lg-8 bottomMarginMedium">
                <p>
                    All <b>licencing activities</b> can be completed on 
                    <a 
                        href={`${window.location.protocol}//${window.location.host}/#${homePageUrl}`}
                        style={{textDecoration: "underline", marginLeft: '5px'}}
                    >{`the ${agencyTypeString} Home Page.`}</a>
                </p>
            </div>
        </div>

        <div className="row topMarginMedium">
            <div className="col-lg-2">
                <Button 
                    id="payment-confirmation-go-home-button"
                    buttonType="regular_primary"
                    text="Go to home page"
                    onClick={() => {dispatch(push(homePageUrl))}}
                />
            </div>
        </div>
    </div>
    )
}